"use strict";
var __create = Object.create;
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __getProtoOf = Object.getPrototypeOf;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __toESM = (mod, isNodeMode, target) => (target = mod != null ? __create(__getProtoOf(mod)) : {}, __copyProps(
  // If the importer is in node compatibility mode or this is not an ESM
  // file that has been converted to a CommonJS file using a Babel-
  // compatible transform (i.e. "__esModule" has not been set), then set
  // "default" to the CommonJS "module.exports" for node compatibility.
  isNodeMode || !mod || !mod.__esModule ? __defProp(target, "default", { value: mod, enumerable: true }) : target,
  mod
));
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: true }), mod);
var Classes_exports = {};
__export(Classes_exports, {
  default: () => Classes_default
});
module.exports = __toCommonJS(Classes_exports);
var React = __toESM(require("react"));
var import_styled_components = __toESM(require("styled-components"));
const SvgIcon = ({
  title,
  titleId,
  desc,
  descId,
  iconSize,
  ariaHidden,
  ...props
}) => /* @__PURE__ */ React.createElement(
  "svg",
  {
    ...props,
    viewBox: "0 0 21 20",
    fill: "currentColor",
    color: "currentColor",
    role: "img",
    "aria-labelledby": titleId,
    "aria-describedby": descId
  },
  desc ? /* @__PURE__ */ React.createElement("desc", { id: descId }, desc) : null,
  title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null,
  /* @__PURE__ */ React.createElement(
    "path",
    {
      d: "M14.8555 16.2461C14.8555 16.4284 14.7904 16.5846 14.6602 16.7148C14.5299 16.8451 14.3737 16.9102 14.1914 16.9102C14.0091 16.9102 13.8529 16.8451 13.7227 16.7148C13.5924 16.5846 13.5273 16.4284 13.5273 16.2461V14.918C13.5273 14.3711 13.332 13.9023 12.9414 13.5117C12.5638 13.1211 12.1016 12.9258 11.5547 12.9258H6.30078C5.75391 12.9258 5.28516 13.1211 4.89453 13.5117C4.50391 13.9023 4.30859 14.3711 4.30859 14.918V16.2461C4.30859 16.4284 4.24349 16.5846 4.11328 16.7148C3.99609 16.8451 3.84635 16.9102 3.66406 16.9102C3.48177 16.9102 3.32552 16.8451 3.19531 16.7148C3.0651 16.5846 3 16.4284 3 16.2461V14.918C3 13.9935 3.31901 13.2057 3.95703 12.5547C4.60807 11.9036 5.38932 11.5781 6.30078 11.5781H11.5547C12.4661 11.5781 13.2409 11.9036 13.8789 12.5547C14.5299 13.2057 14.8555 13.9935 14.8555 14.918V16.2461ZM8.91797 10.25C8.01953 10.25 7.24479 9.92448 6.59375 9.27344C5.95573 8.6224 5.63672 7.83464 5.63672 6.91016C5.63672 5.9987 5.95573 5.21745 6.59375 4.56641C7.24479 3.91536 8.01953 3.58984 8.91797 3.58984C9.82943 3.58984 10.6042 3.91536 11.2422 4.56641C11.8932 5.21745 12.2188 5.9987 12.2188 6.91016C12.2188 7.83464 11.8932 8.6224 11.2422 9.27344C10.6042 9.92448 9.82943 10.25 8.91797 10.25ZM18 14.7422C18 14.9115 17.9349 15.0547 17.8047 15.1719C17.6875 15.2891 17.5443 15.3477 17.375 15.3477C17.1927 15.3477 17.0365 15.2891 16.9062 15.1719C16.7891 15.0547 16.7305 14.9115 16.7305 14.7422V13.5508C16.7305 13.1471 16.6003 12.7826 16.3398 12.457C16.0794 12.1315 15.7344 11.9167 15.3047 11.8125C15.1484 11.7734 15.0247 11.6823 14.9336 11.5391C14.8424 11.3958 14.8164 11.2461 14.8555 11.0898C14.9076 10.9336 15.0052 10.8164 15.1484 10.7383C15.3047 10.6471 15.4674 10.6211 15.6367 10.6602C16.3268 10.8294 16.8932 11.1875 17.3359 11.7344C17.7786 12.2682 18 12.8737 18 13.5508V14.7422ZM13.0586 5.17188C12.8893 5.13281 12.7591 5.04167 12.668 4.89844C12.5898 4.75521 12.5703 4.60547 12.6094 4.44922C12.6484 4.29297 12.7396 4.17578 12.8828 4.09766C13.0391 4.00651 13.1953 3.98047 13.3516 4.01953C14.0417 4.1888 14.6016 4.54688 15.0312 5.09375C15.4609 5.6276 15.6758 6.23307 15.6758 6.91016C15.6758 7.60026 15.4609 8.21875 15.0312 8.76562C14.6016 9.29948 14.0417 9.65104 13.3516 9.82031C13.1953 9.85938 13.0391 9.83984 12.8828 9.76172C12.7396 9.67057 12.6484 9.54688 12.6094 9.39062C12.5703 9.22135 12.5898 9.07161 12.668 8.94141C12.7591 8.79818 12.8893 8.70052 13.0586 8.64844C13.4622 8.55729 13.7943 8.34896 14.0547 8.02344C14.3151 7.69792 14.4453 7.32682 14.4453 6.91016C14.4453 6.50651 14.3151 6.14193 14.0547 5.81641C13.7943 5.49089 13.4622 5.27604 13.0586 5.17188ZM8.91797 8.92188C9.46484 8.92188 9.92708 8.72656 10.3047 8.33594C10.6953 7.94531 10.8906 7.47005 10.8906 6.91016C10.8906 6.36328 10.6953 5.89453 10.3047 5.50391C9.92708 5.11328 9.46484 4.91797 8.91797 4.91797C8.37109 4.91797 7.90234 5.11328 7.51172 5.50391C7.13411 5.89453 6.94531 6.36328 6.94531 6.91016C6.94531 7.47005 7.13411 7.94531 7.51172 8.33594C7.90234 8.72656 8.37109 8.92188 8.91797 8.92188Z",
      fill: "currentColor"
    }
  )
);
const SvgClasses = (0, import_styled_components.default)(SvgIcon)(({ iconSize, color }) => {
  const getIconSize = () => {
    const standardIconSize = {
      s: "17px",
      // 17px small
      m: "20px",
      // 20px medium
      l: "24px",
      // 24px large
      xl: "32px",
      // 32px extraLarge
      inherit: "inherit"
      // inherits size from parent
    };
    return standardIconSize[iconSize];
  };
  return import_styled_components.css`
    width: ${getIconSize()};
    height: ${getIconSize()};
    display: inline-block;
    color: ${color};
  `;
});
var Classes_default = SvgClasses;
